import styled from 'styled-components';
import Icon from '../../assets/images/tick-green-circle-hollow-icon.svg';

interface TickGreenCircleHollowIconProps {
  /** Icon height in `px`. Defaults to `28px`. */
  height?: string;

  /** Icon width in `px`. Defaults to `28px`. */
  width?: string;
}

const TickGreenCircleHollowIcon = styled.span<TickGreenCircleHollowIconProps>`
  ${({ height = '28px', width = '28px' }) => `
    background: url(\"${Icon}\") no-repeat left center;
    background-size: ${width} ${height};
    display: inline-block;
    height: ${height};
    position: relative;
    width: ${width};
  `}
`;

export default TickGreenCircleHollowIcon;
